export function readSession(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (_error) {
    return null;
  }
}

export function writeSession(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (_error) {
    // Ignore session storage failures in private/blocked modes.
  }
}
